import React, { useState, useEffect } from "react";
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import { Form, Button, Card, Alert, Spinner } from "react-bootstrap";
import imageplus from "../assets/img/imageplus3.svg";
import "../assets/styles/PushNotification.css";
import Reports from "../components/PushNotificationReports";
import notificationService from "../../services/notificationService";
import analyticsService from "../../services/analyticsService";
// import billingService from "../../services/billingService";
import authService from "../../services/authService";




const PushNotification = () => {
  // User and Permissions State
  const [currentUser, setCurrentUser] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});

  // Data state
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [loadingCount, setLoadingCount] = useState(false);

  // UI state
  const [activeTab, setActiveTab] = useState("send");
  const [alert, setAlert] = useState(null);

  // Form state
  const [formData, setFormData] = useState({
    title: '',
    body: '',
    callToAction: '',
    state: '',
    city: '',
    package: ''
  });

  // Send options state
  const [sendToOptions, setSendToOptions] = useState({
    agents: true,
    agency: false,
    builders: true,
  });

  const [userTargeting, setUserTargeting] = useState({
    allUsers: false,
    allNonSubscribers: true,
    allSubscribers: false,
    allUnSubscribers: true,
    allInactiveUsers: false,
  });

  // Images state
  const [images, setImages] = useState([null, null]);
  const [imageFiles, setImageFiles] = useState([null, null]);

  // User count state
  const [userCount, setUserCount] = useState(0);
  const [countBreakdown, setCountBreakdown] = useState({});

  // Dynamic dropdown options
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [allCitiesData, setAllCitiesData] = useState({});
  // const [packageOptions, setPackageOptions] = useState([]);

  const staticCityOptions = [
    { value: "hyderabad", label: "Hyderabad" },
    { value: "bangalore", label: "Bangalore" },
    { value: "chennai", label: "Chennai" },
    { value: "mumbai", label: "Mumbai" },
  ];

  // const staticPackageOptions = [
  //   { value: "basic", label: "Basic Package" },
  //   { value: "standard", label: "Standard Package" },
  //   { value: "premium", label: "Premium Package" },
  // ];

  const actionOptions = [
    { value: "Open App", label: "Open App" },
    { value: "Visit Website", label: "Visit Website" },
    { value: "Subscription", label: "Subscription" },
  ];

  const userOptions = [
    "All Users",
    "All Non-Subscribers",
    "All Subscribers",
    "All Unsubscribers",
    "All Inactive Users",
  ];

  // Load user data and permissions
  const loadUserData = async () => {
    try {
      const user = await authService.getCurrentUser();
      if (user) {
        setCurrentUser(user);
        setUserPermissions(user.permissions || {});
      }
    } catch (error) {
      console.error('Error loading user data:', error);
    }
  };

  // Load dropdown options from APIs (exact app logic)
  const loadDropdownOptions = async () => {
    try {
      const citiesStatesResponse = await analyticsService.getCitiesAndStates();
      if (citiesStatesResponse.success && citiesStatesResponse.data) {
        const { states, citiesByState } = citiesStatesResponse.data;
        setStateOptions(['Select All', ...[...new Set((states || []).map(s => s.replace(/\s+\d{5,6}\s*$/, '').trim()))].sort()]);
        setAllCitiesData(citiesByState || {});
      }

      // try {
      //   const packagesResponse = await billingService.getPublicSubscriptionPlans();
      //   if (packagesResponse.success && packagesResponse.data?.plans) {
      //     const planNames = [...new Set(packagesResponse.data.plans.map(pkg => pkg.package_name).filter(Boolean))];
      //     setPackageOptions(['Select All', ...planNames]);
      //   } else {
      //     setPackageOptions(['Select All', ...staticPackageOptions.map(p => p.label)]);
      //   }
      // } catch {
      //   setPackageOptions(['Select All', ...staticPackageOptions.map(p => p.label)]);
      // }
    } catch (error) {
      console.error('Error loading dropdown options:', error);
      // setPackageOptions(['Select All', ...staticPackageOptions.map(p => p.label)]);
    }
  };

  // Fetch user count based on current filters (exact app logic)
  const fetchUserCount = async () => {
    try {
      setLoadingCount(true);
      const filters = {
        sendTo: sendToOptions,
        userTargeting: userTargeting,
        state: formData.state === 'Select All' ? '' : formData.state,
        city: formData.city === 'Select All' ? '' : formData.city,
        package: formData.package === 'Select All' ? '' : formData.package,
        role: 'admin',
      };

      const response = await notificationService.getUserCount(filters);
      if (response.success) {
        const payload = response.data || response;
        setUserCount(payload.count || 0);
        setCountBreakdown(payload.breakdown || {});
      } else {
        setUserCount(estimateUserCount());
      }
    } catch (error) {
      console.error('Error fetching user count:', error);
      setUserCount(estimateUserCount());
    } finally {
      setLoadingCount(false);
    }
  };

  // Fallback user count estimation
  const estimateUserCount = () => {
    let count = 0;
    const baseCounts = { agents: 450, agency: 120, builders: 85 };

    Object.keys(sendToOptions).forEach(key => {
      if (sendToOptions[key]) {
        count += baseCounts[key] || 0;
      }
    });

    if (!userTargeting.allUsers) {
      let percentage = 0;
      if (userTargeting.allNonSubscribers) percentage += 0.4;
      if (userTargeting.allSubscribers) percentage += 0.3;
      if (userTargeting.allUnSubscribers) percentage += 0.2;
      if (userTargeting.allInactiveUsers) percentage += 0.1;
      count = Math.floor(count * percentage);
    }

    return count;
  };

  // Effects
  useEffect(() => {
    loadUserData();
    loadDropdownOptions();
  }, []);

  useEffect(() => {
    if (activeTab === 'send') {
      fetchUserCount();
    }
  }, [sendToOptions, userTargeting, formData.state, formData.city, formData.package, activeTab]);

  // Handle form changes (exact app logic)
  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));

    if (field === 'state') {
      if (value && value !== 'Select All') {
        setCityOptions(['Select All', ...(allCitiesData[value] || [])]);
      } else {
        setCityOptions([]);
      }
      setFormData(prev => ({ ...prev, state: value, city: '' }));
    }
  };

  // Handle send to options
  const handleSendToChange = (option) => {
    setSendToOptions(prev => ({
      ...prev,
      [option]: !prev[option]
    }));
  };

  // Handle user targeting
  const handleUserTargetingChange = (option) => {
    if (option === 'allUsers') {
      const newAllUsersState = !userTargeting.allUsers;
      setUserTargeting({
        allUsers: newAllUsersState,
        allNonSubscribers: newAllUsersState,
        allSubscribers: newAllUsersState,
        allUnSubscribers: newAllUsersState,
        allInactiveUsers: newAllUsersState,
      });
    } else {
      setUserTargeting(prev => ({
        ...prev,
        [option]: !prev[option]
      }));
    }
  };

  // Legacy function for compatibility - maps to new user targeting
  const handleCheck = (option) => {
    const optionMap = {
      "All Users": "allUsers",
      "All Non-Subscribers": "allNonSubscribers",
      "All Subscribers": "allSubscribers",
      "All Unsubscribers": "allUnSubscribers",
      "All Inactive Users": "allInactiveUsers"
    };

    const mappedOption = optionMap[option];
    if (mappedOption) {
      handleUserTargetingChange(mappedOption);
    }

    // Legacy function now just handles the new state - no selected array needed
  };

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (1MB limit)
      if (file.size > 1024 * 1024) {
        setAlert({ type: 'error', message: 'Image file size must be less than 1MB' });
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        setAlert({ type: 'error', message: 'Please select a valid image file' });
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const updatedImages = [...images];
        const updatedFiles = [...imageFiles];
        updatedImages[index] = reader.result;
        updatedFiles[index] = file;
        setImages(updatedImages);
        setImageFiles(updatedFiles);
      };
      reader.readAsDataURL(file);
    }
  };

  // Handle form submission
  const handleSendNotification = async () => {
    // Validation
    if (!formData.title || !formData.body) {
      setAlert({ type: 'error', message: 'Please fill in notification title and body' });
      return;
    }

    const hasSelectedUserGroup = sendToOptions.agents || sendToOptions.agency || sendToOptions.builders;
    if (!hasSelectedUserGroup) {
      setAlert({ type: 'error', message: 'Please select at least one user group (Agents, Agency, or Builders)' });
      return;
    }

    // Confirm before sending
    if (!window.confirm(`Send notification to ${userCount} users?`)) {
      return;
    }

    try {
      setSending(true);
      setAlert(null);

      // Upload images if selected
      let image1Url = null;
      let image2Url = null;

      if (imageFiles[0]) {
        const uploadResult1 = await notificationService.uploadNotificationImage(imageFiles[0]);
        if (uploadResult1.success) {
          image1Url = uploadResult1.url;
        } else {
          throw new Error('Failed to upload first image');
        }
      }

      if (imageFiles[1]) {
        const uploadResult2 = await notificationService.uploadNotificationImage(imageFiles[1]);
        if (uploadResult2.success) {
          image2Url = uploadResult2.url;
        } else {
          throw new Error('Failed to upload second image');
        }
      }

      // Send notification
      const response = await notificationService.sendPushNotification({
        title: formData.title,
        body: formData.body,
        sendTo: sendToOptions,
        userTargeting: userTargeting,
        state: formData.state === 'Select All' ? '' : formData.state,
        city: formData.city === 'Select All' ? '' : formData.city,
        package: formData.package === 'Select All' ? '' : formData.package,
        callToAction: formData.callToAction,
        image1: image1Url,
        image2: image2Url,
      });

      if (response.success) {
        setAlert({
          type: 'success',
          message: `Notification sent successfully to ${response.sentCount || userCount} users!`
        });

        // Reset form
        setFormData({
          title: '',
          body: '',
          callToAction: '',
          state: '',
          city: '',
          package: ''
        });
        setCityOptions([]);
        setImages([null, null]);
        setImageFiles([null, null]);
      } else {
        throw new Error(response.message || 'Failed to send notification');
      }
    } catch (error) {
      console.error('Error sending notification:', error);
      setAlert({ type: 'error', message: error.message || 'Failed to send notification. Please try again.' });
    } finally {
      setSending(false);
    }
  };
 

  return (
     
    <div className="d-flex">
      <LeftNav />
      <div className="flex-grow-1">
        <TopNav />
        <div className="p-4">
        <div className="push-container">
            <div className="push-notifheader mt-3">Send Push Notification</div>

            {/* Alert Messages */}
            {alert && (
              <Alert
                variant={alert.type === 'error' ? 'danger' : 'success'}
                className="mt-3"
                dismissible
                onClose={() => setAlert(null)}
              >
                {alert.message}
              </Alert>
            )}

            <div className="push-tabs mt-2">
              <div className="tab-wrapper">
                <button
                  className={`tab-btn ${activeTab === "send" ? "active" : ""}`}
                  onClick={() => setActiveTab("send")}
                >
                  Send
                </button>
                <button
                  className={`tab-btn ${activeTab === "reports" ? "active" : ""}`}
                  onClick={() => setActiveTab("reports")}
                >
                  Reports
                </button>
              </div>
            </div>

          <Card className="push-card">

            {activeTab === "send" && (
              <Form className="push-form">
                {/* User Count Display */}
                <div className="credits-box d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <p className="mb-0 credits-label mt-2">Target Audience</p>
                    <div className="d-flex align-items-center mt-2">
                      <h3 className="credits-value mb-0">
                        {loadingCount ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          userCount.toLocaleString()
                        )}
                      </h3>
                      <span className="ms-2 text-muted">users will receive this notification</span>
                    </div>
                    {countBreakdown && Object.keys(countBreakdown).length > 0 && (
                      <div className="mt-2">
                        <small className="text-muted">
                          {Object.entries(countBreakdown).map(([key, value]) => (
                            <span key={key} className="me-3">
                              {key}: <strong>{value}</strong>
                            </span>
                          ))}
                        </small>
                      </div>
                    )}
                  </div>

                </div>

                {/* Send To Section - Top */}
                <div className="send-to-box-top mb-3">
                  <Form.Label>Send to</Form.Label>
                  <div className="d-flex gap-4 mt-2">
                    <Form.Check
                      type="checkbox"
                      id="agents"
                      label="Agents"
                      className="checkbox-inline"
                      checked={sendToOptions.agents}
                      onChange={() => handleSendToChange('agents')}
                    />
                    <Form.Check
                      type="checkbox"
                      id="agency"
                      label="Agency"
                      className="checkbox-inline"
                      checked={sendToOptions.agency}
                      onChange={() => handleSendToChange('agency')}
                    />
                    <Form.Check
                      type="checkbox"
                      id="builders"
                      label="Builders"
                      className="checkbox-inline"
                      checked={sendToOptions.builders}
                      onChange={() => handleSendToChange('builders')}
                    />
                  </div>
                </div>
              


                {/* State Dropdown */}
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Select
                    className="push-input"
                    value={formData.state}
                    onChange={(e) => handleFormChange('state', e.target.value)}
                  >
                    <option value="">Select state</option>
                    {stateOptions.map((state, index) => (
                      <option key={`state-${index}`} value={state}>{state}</option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {/* City Dropdown — only shown when a state is selected (exact app logic) */}
                {formData.state && formData.state !== 'Select All' && (
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <Form.Select
                      className="push-input"
                      value={formData.city}
                      onChange={(e) => handleFormChange('city', e.target.value)}
                    >
                      <option value="">Select city</option>
                      {cityOptions.map((city, index) => (
                        <option key={`city-${index}`} value={city}>{city}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                )}

                {/* <Form.Group className="mb-3">
                  <Form.Label>Package</Form.Label>
                  <Form.Select
                    className="push-input"
                    value={formData.package}
                    onChange={(e) => handleFormChange('package', e.target.value)}
                  >
                    <option value="">Select package</option>
                    {packageOptions.map((pkg, index) => (
                      <option key={index} value={pkg}>
                        {pkg}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group> */}

                <Form.Group className="mb-3">
                  <Form.Label>Notification Title</Form.Label>
                  <Form.Control
                    type="text"
                    className="push-input"
                    placeholder="Enter notification title..."
                    value={formData.title}
                    onChange={(e) => handleFormChange('title', e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Notification Body</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter notification message..."
                    value={formData.body}
                    onChange={(e) => handleFormChange('body', e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Call to action</Form.Label>
                  <Form.Select
                    className="push-input"
                    value={formData.callToAction}
                    onChange={(e) => handleFormChange('callToAction', e.target.value)}
                  >
                    <option value="">Select</option>
                    {actionOptions.map((a) => (
                      <option key={a.value} value={a.value}>
                        {a.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {/* Send To Users Section */}
                <div className="send-to-box">
                  <p className="send-label">Send to</p>
                  {userOptions.map((option) => {
                    const optionMap = {
                      "All Users": userTargeting.allUsers,
                      "All Non-Subscribers": userTargeting.allNonSubscribers,
                      "All Subscribers": userTargeting.allSubscribers,
                      "All Unsubscribers": userTargeting.allUnSubscribers,
                      "All Inactive Users": userTargeting.allInactiveUsers
                    };

                    return (
                      <Form.Check
                        key={option}
                        type="checkbox"
                        id={option}
                        label={option}
                        checked={optionMap[option] || false}
                        onChange={() => handleCheck(option)}
                        className={optionMap[option] ? "checkbox-active" : "checkbox-inactive"}
                      />
                    );
                  })}
                </div>

                {/* ✅ Upload Images */}
                <div className="upload-section">
                  <p className="upload-label">Add Images</p>

                  {[0, 1].map((i) => (
                    <div key={i} className="upload-box">
                      {images[i] ? (
                        <img src={images[i]} alt="Preview" className="upload-preview" />
                      ) : (
                        <div className="upload-inner">
                          <img src={imageplus} alt="Upload Icon" className="upload-icon-img" />
                          <p className="upload-text">
                            {i === 0 ? (
                              <>
                                <span>Image ratio 512 x 256px or 1024 x 512px</span>
                                <span className="sub-text mt-2 d-block">Max file size 1mb</span>
                              </>
                            ) : (
                              <>
                                <span>Image size 640 x 960px</span>
                                <span className="sub-text mt-2 d-block">Max file size 1mb</span>
                              </>
                            )}
                          </p>
                          <label className="upload-btn mt-2">
                            <span className="upload-imagetext">Upload Image</span>
                            <input
                              type="file"
                              accept="image/*"
                              hidden
                              onChange={(e) => handleImageChange(e, i)}
                            />
                          </label>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="text-end">
                  <button
                    className="btn-pushnotify"
                    onClick={handleSendNotification}
                    disabled={sending}
                    type="button"
                  >
                    {sending ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        <span className="btn-pushnotifytext">Sending...</span>
                      </>
                    ) : (
                      <span className="btn-pushnotifytext">Send Notification</span>
                    )}
                  </button>
                </div>

                {/* Submit */}
               
              </Form>
            )}

           {activeTab === "reports" && (
  <Reports />
)}

          </Card>
        </div>
        </div>
      </div>
    </div>
    
  );
};

export default PushNotification;